import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { Command } from '../command.model'

@Injectable({ providedIn: 'root' })
export class CommandRegistryService {

    public readonly commands: Observable<Array<Command>>

    private readonly commands$ = new BehaviorSubject<Array<Command>>([])

    constructor() {
        this.commands = this.commands$.asObservable()
    }

    public register(commands: Array<Command>): void {
        const current = this.commands$.value
        const existingIds = new Set(current.map(c => c.id))
        const incoming = commands.filter(c => !existingIds.has(c.id))
        if (incoming.length === 0) {
            return
        }
        this.commands$.next([...current, ...incoming])
    }

    public unregister(commandIds: Array<string>): void {
        const ids = new Set(commandIds)
        this.commands$.next(this.commands$.value.filter(c => !ids.has(c.id)))
    }

    public getAll(): Array<Command> {
        return this.commands$.value
    }
}